import axios from 'axios';
const AUTH_API_URL = 'https://apxappdev.noidapower.com:8164/chdd/master/oauth/token';
const AUTH_API_URL_CHDCRMD = 'https://apxappdev.noidapower.com:8164/chdd/chdcrmd/oauth/token';
// const AUTH_API_URL = 'https://apxappqas.noidapower.com:3000/api/token';
// const AUTH_API_URL_CHDCRMD = 'https://apxappqas.noidapower.com:3000/api/token';
//  const AUTH_API_URL = 'https://gtw5.noidapower.com:9163/api/token';
//  const AUTH_API_URL_CHDCRMD = 'https://gtw5.noidapower.com:9163/api/token';
// const AUTH_API_URL = 'https://cportal.chandigarhpower.com:4865/api/token';
// const AUTH_API_URL_CHDCRMD = 'https://cportal.chandigarhpower.com:4865/api/token';
 
const CLIENT_ID = '9AlaZUEzKmAWfotKmV0GZQ..';
const CLIENT_SECRET = '3UuTe33M47JGZoSaG44Q5Q..';
// const CLIENT_ID = 'Nc6_RTxV1ZEHs3SgOj5-Xw..';
// const CLIENT_SECRET = 'TbPNSScdb6vxNtoTtZmEnQ..';
// const CLIENT_ID = 'wIsITieUgYQLK-CAIxX1tQ..';
// const CLIENT_SECRET = 'g63Xo8ux4LNeewbwSxPg5Q..';

const CLIENT_ID_CHDCRMD = 'TVFK4vM1rWn1JQw4CZLjcg..';
const CLIENT_SECRET_CHDCRMD = 'yF55djDhJ7Av4Tc2pbPpWA..';
// const CLIENT_ID_CHDCRMD = 'i_ZIR_i0EK9I_mMYAcK6KQ..';
// const CLIENT_SECRET_CHDCRMD = 'mOxolXG_ehb_zVvx6UJHfQ..';
// const CLIENT_ID_CHDCRMD = 'yVZxVs84CFtFqO6_PmFp-Q..';
// const CLIENT_SECRET_CHDCRMD = 'bMBVkd8a2yh-01QsR43BfQ..';
class AuthService {
    async generateToken() {
        try {
            const formData1 = new URLSearchParams();
            formData1.append('grant_type', 'client_credentials');
            formData1.append('client_id', CLIENT_ID);
            formData1.append('client_secret', CLIENT_SECRET);
            const basicAuth1 = btoa(`${CLIENT_ID}:${CLIENT_SECRET}`);
            const response1 = await axios.post(AUTH_API_URL, formData1, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'Authorization': `Basic ${basicAuth1}`
                }
                // headers: {
                //     'Content-Type': 'application/x-www-form-urlencoded',
                //     'Authorization':  'Bearer b9e0c4b5-8477-4de3-9041-5f7a98f295c7',
                //     'x-token-target': 'master'    
                // }
        //         headers: {
        //             'Content-Type': 'application/x-www-form-urlencoded',
        //             'Authorization':  'Bearer b9e0c4b5-8477-4de3-9041-5f7a98f295c7',
        //             'x-token-target': 'master'
        //           },
               
            });
            const formData2 = new URLSearchParams();
            formData2.append('grant_type', 'client_credentials');
            formData2.append('client_id', CLIENT_ID_CHDCRMD);
            formData2.append('client_secret', CLIENT_SECRET_CHDCRMD);
            const basicAuth2 = btoa(`${CLIENT_ID_CHDCRMD}:${CLIENT_SECRET_CHDCRMD}`);
            const response2 = await axios.post(AUTH_API_URL_CHDCRMD, formData2, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'Authorization': `Basic ${basicAuth2}`
                }
                // headers: {
                //     'Content-Type': 'application/x-www-form-urlencoded',
                //     'Authorization':  'Bearer b9e0c4b5-8477-4de3-9041-5f7a98f295c7',
                //     'x-token-target': 'chd'      
                // }
        //         headers: {
        //             'Content-Type': 'application/x-www-form-urlencoded',
        //             'Authorization':  'Bearer b9e0c4b5-8477-4de3-9041-5f7a98f295c7',
        //             'x-token-target': 'chd'
        //           },
            });
            if (response1.data?.access_token && response2.data?.access_token) {
                sessionStorage.setItem('access_token', response1.data.access_token);
                sessionStorage.setItem('access_token_chdcrmd', response2.data.access_token);
                return {
                    masterToken: response1.data.access_token,
                    chdcrmdToken: response2.data.access_token
                };
            }
            throw new Error('Tokens not received in response');
        } catch (error) {
            console.error('Error generating tokens:', error);
            if (error.response) {
                console.error('Response data:', error.response.data);
                console.error('Response status:', error.response.status);
                console.error('Response headers:', error.response.headers);
            }
            throw error;
        }
    }
    getToken() {
        return sessionStorage.getItem('access_token');
    }
    getChdcrmdToken() {
        return sessionStorage.getItem('access_token_chdcrmd');
    }
    isTokenValid() {
        const token = this.getToken();
        const chdcrmdToken = this.getChdcrmdToken();
        return !!(token && chdcrmdToken);
    }
    clearToken() {
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('access_token_chdcrmd');
    }
}
export default new AuthService();
